<script setup lang="ts">
import { SimpleDialog } from "ls/components/simple-dialog";
import { RpErrorTypes } from "@/generated/models";
import { useAccessControlErrorsFilter } from "../../access-control/useAccessControl";
import { useOrganization } from "../../organizations/useOrganization";
import OnlineProjectCloudPlusRequiredDialogContent from "./OnlineProjectCloudPlusRequiredDialogContent.vue";
import OnlineProjectCloudRoleRequiredDialogContent from "./OnlineProjectCloudRoleRequiredDialogContent.vue";
import OnlineProjectCloudSeatRequiredDialogContent from "./OnlineProjectCloudSeatRequiredDialogContent.vue";

const { isOpen, error, isError } = useAccessControlErrorsFilter([
  RpErrorTypes.CloudPlusRequired,
  RpErrorTypes.CloudAuthorSeatRequired,
  RpErrorTypes.CloudAuthorRoleRequired,
]);

const organization = useOrganization(() => error.value?.payload.OrganizationId);
</script>

<template>
  <SimpleDialog
    v-if="isError"
    v-model:open="isOpen"
  >
    <template v-if="organization && error">
      <OnlineProjectCloudRoleRequiredDialogContent
        v-if="error.type === RpErrorTypes.CloudAuthorRoleRequired"
        :organization="organization"
      />
      <OnlineProjectCloudSeatRequiredDialogContent
        v-else-if="error.type === RpErrorTypes.CloudAuthorSeatRequired"
        :organization="organization"
      />
      <OnlineProjectCloudPlusRequiredDialogContent
        v-else-if="error.type === RpErrorTypes.CloudPlusRequired"
        :organization="organization"
        :payload="error.payload"
      />
    </template>
  </SimpleDialog>
</template>
